<template>
  <div id="chartId" style="width:500px;height:400px;border: 1px solid #efefef;padding:10px" />
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {};
  },
  mounted() {
    this.initechart();
  },
  methods: {
    initechart() {
      this.echart = echarts.init(this.$el);
      this.setOptions();
    },
    // setOptions() {
    //   this.echart.setOption({
    //     title: {
    //       text: "底盘斜角"
    //       // subtext:'底盘斜角'
    //     },
    //     xAxis: {
    //       name: "X轴",
    //       axisTick: {
    //         alignWithLabel: true
    //       },
    //       splitLine: {
    //         show: true,
    //         lineStyle: {
    //           color: ["#f8f8f8"],
    //           width: 2,
    //           type: "solid"
    //         }
    //       },
    //       type: "category",
    //       data: ["0.5", "1.0", "1.5", "2.0", "2.5", "3.0", "3.5"]
    //     },
    //     yAxis: {
    //       name: "Y轴",
    //       type: "value",
    //       splitLine: {
    //         show: true,
    //         lineStyle: {
    //           color: ["#f8f8f8"],
    //           width: 2,
    //           type: "solid"
    //         }
    //       }
    //     },
    //     series: [
    //       {
    //         symbol: "circle",
    //         itemStyle: {
    //           normal: {
    //             color: "#fff",
    //             borderColor: "#00ebc2",
    //             borderWidth: 2
    //           }
    //         },
    //         data: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5],
    //         type: "scatter"
    //       }
    //     ]
    //   });
    // }
    setOptions() {
      var symbolSize = 10;
      var data = [[0.5, 3.5], [3, 1.5], [2.0, 2.5], [3.0, 3.5]];
      var points = [];
      this.echart.setOption({
        title: {
          text: "底盘斜角",
          textStyle: {
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: "normal"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            var data = params.data || [0, 0];
            return data[0].toFixed(2) + ", " + data[1].toFixed(2);
          }
        },
        grid: {
          left: "1%",
          right: "7%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          min: 0,
          max: 3.5,
          splitNumber: 6,
          name: "X轴",
          type: "value",
          scale: true,
          gridIndex: 0,
          nameTextStyle: {
            color: "#888"
          },
          axisTick: {
            show: false,
            xAxisIndex: 0
          },
          axisLine: {
            show: true,
            onZro: true,
            lineStyle: {
              color: "#F7F7F7",
              width: 1 //这里是为了突出显示加上的
            }
          },
          axisLabel: {
            show: true,
            formatter: function(value, index) {
              if (value === 0) {
                return value.toFixed(0);
              } else {
                return value.toFixed(1);
              }
            },
            textStyle: {
              color: "#888"
            }
          },
          splitLine: {
            show: true,
            scale: true,
            lineStyle: {
              color: ["#F7F7F7"],
              width: 2,
              type: "solid"
            }
          }
        },
        yAxis: {
          name: "Y轴",
          min: 0,
          max: 3.5,
          type: "value",
          nameTextStyle: {
            color: "#888"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#F7F7F7",
              width: 1 //这里是为了突出显示加上的
            }
          },
          axisLabel: {
            show: true,
            formatter: function(value, index) {
              if (value === 0) {
                return;
              } else {
                return value.toFixed(1);
              }
            },
            textStyle: {
              color: "#888"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#F7F7F7"],
              width: 2,
              type: "solid"
            }
          }
        },
        series: [
          // {
          //   id: "a",
          //   type: "scatter",
          //   smooth: true,
          //   symbolSize: symbolSize,
          //   data: data,
          //   itemStyle: {
          //     normal: {
          //       color: "#F9F9F9",
          //       borderColor: "#00ebc2",
          //       borderWidth: 2
          //     }
          //   }
          // }
        ]
      });
    }
  }
};
</script>

